export default __webpack_public_path__ + "assets/e69eed7b067ef0a66bd350f2fe2c7252.jpg";